module.exports = __webpack_public_path__ + "img/tagsample.ffe28807.png";